export const condimentListLanguage = {
    en: {
        'Condiment List': 'Condiment List',
        'Add Condiment': 'Add Condiment',
        'Group Name': 'Group Name',
        'Selection Type': 'Selection Type',
        'Action': 'Action',
        'Are you sure you want to delete this condiment?': 'Are you sure you want to delete this condiment?',
        'Condiment deleted successfully': 'Condiment deleted successfully',
        'Failed to delete Condiment. Please try again later.': 'Failed to delete Condiment. Please try again later.',
        'Single': 'Single',
        'Multiple': 'Multiple',
        'Required 1': 'Required 1',
        'Condiment :': 'Condiment :',
        'Condiment N': 'Condiment name',
        'Price': 'Price',
        'SetDef': 'Set Default',
        'Submit': 'Submit',
        'Cancel': 'Cancel',
        'Add/Edit Condiment': 'Add/Edit Condiment',
    },
    th: {
        'Condiment List': 'ข้อมูลรายการชุดตัวเลือก',
        'Add Condiment': 'เพิ่มเครื่องปรุง',
        'Group Name': 'ชื่อกลุ่ม',
        'Selection Type': 'ประเภทการเลือก',
        'Action': 'การกระทำ',
        'Are you sure you want to delete this condiment?': 'คุณแน่ใจหรือไม่ว่าต้องการลบเครื่องปรุงนี้?',
        'Condiment deleted successfully': 'ลบเครื่องปรุงสำเร็จ',
        'Failed to delete Condiment. Please try again later.': 'ลบเครื่องปรุงไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        'Single': 'เดี่ยว',
        'Multiple': 'หลายรายการ',
        'Required 1': 'จำเป็น 1',
        'Condiment :': 'เครื่องปรุง :',
        'Condiment N': 'ชื่อเครื่องปรุง',
        'Price': 'ราคา',
        'SetDef': 'ตั้งเป็นค่าเริ่มต้น',
        'Submit': 'ส่ง',
        'Cancel': 'ยกเลิก',
        'Add/Edit Condiment': 'เพิ่ม/แก้ไขเครื่องปรุง',
    },
    cn: {
        'Condiment List': '调味品列表',
        'Add Condiment': '添加调味品',
        'Group Name': '组名',
        'Selection Type': '选择类型',
        'Action': '操作',
        'Are you sure you want to delete this condiment?': '您确定要删除此调味品吗？',
        'Condiment deleted successfully': '调味品删除成功',
        'Failed to delete Condiment. Please try again later.': '删除调味品失败，请稍后再试。',
        'Single': '单选',
        'Multiple': '多选',
        'Required 1': '必选 1',
        'Condiment :': '调味品：',
        'Condiment N': '调味品名称',
        'Price': '价格',
        'SetDef': '设为默认',
        'Submit': '提交',
        'Cancel': '取消',
        'Add/Edit Condiment': '添加/编辑调味品',
    },
    jp: {
        'Condiment List': '調味料リスト',
        'Add Condiment': '調味料を追加',
        'Group Name': 'グループ名',
        'Selection Type': '選択タイプ',
        'Action': '操作',
        'Are you sure you want to delete this condiment?': 'この調味料を削除してもよろしいですか？',
        'Condiment deleted successfully': '調味料が正常に削除されました',
        'Failed to delete Condiment. Please try again later.': '調味料の削除に失敗しました。後でもう一度お試しください。',
        'Single': '単一',
        'Multiple': '複数',
        'Required 1': '必須 1',
        'Condiment :': '調味料：',
        'Condiment N': '調味料名',
        'Price': '価格',
        'SetDef': 'デフォルトに設定',
        'Submit': '送信',
        'Cancel': 'キャンセル',
        'Add/Edit Condiment': '調味料の追加/編集',
    },
    kr: {
        'Condiment List': '조미료 목록',
        'Add Condiment': '조미료 추가',
        'Group Name': '그룹 이름',
        'Selection Type': '선택 유형',
        'Action': '동작',
        'Are you sure you want to delete this condiment?': '이 조미료를 삭제하시겠습니까?',
        'Condiment deleted successfully': '조미료가 성공적으로 삭제되었습니다',
        'Failed to delete Condiment. Please try again later.': '조미료 삭제에 실패했습니다. 나중에 다시 시도해 주세요.',
        'Single': '단일',
        'Multiple': '다중',
        'Required 1': '필수 1',
        'Condiment :': '조미료 :',
        'Condiment N': '조미료 이름',
        'Price': '가격',
        'SetDef': '기본값으로 설정',
        'Submit': '제출',
        'Cancel': '취소',
        'Add/Edit Condiment': '조미료 추가/편집',
    }
}